import React, {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import CardDealerService from '@adv-mt/mt-card-dealer-service'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {CONTEXTS as sectionServicesContext} from './config.js'

const BASE_CLASS = `mt-SectionServices`

function SectionServicesModalContent({context = sectionServicesContext.DETAIL, services}) {
  const {i18n} = useContext(Context)

  const isSubscriptionDetailsContext = context === sectionServicesContext.DETAIL_SUBSCRIPTION
  const isSubscriptionContext = isSubscriptionDetailsContext || context === sectionServicesContext.STOCK_SUBSCRIPTION

  const preTitleText = isSubscriptionContext ? null : i18n.t('DEALER_SERVICE.DEALER_SERVICES_TITLE')

  const titleText = isSubscriptionContext
    ? i18n.t('DEALER_SERVICE.DEALER_SERVICES_SUBSCRIPTION_TITLE')
    : i18n.t('DEALER_SERVICE.DEALER_SERVICES_PRETITLE')

  return (
    <>
      <TitleBasic as={titleBasicTags.h2} preTitle={preTitleText} title={titleText} size={titleBasicSizes.s} />
      <div className={`${BASE_CLASS}-modalContent`}>
        {services.map(service => (
          <div className={`${BASE_CLASS}-modalService`} key={service.type}>
            <CardDealerService
              id={service.type}
              type={isSubscriptionDetailsContext ? 'compact' : 'extended'}
              service={service.title}
              description={service.description}
              isIncluded={service.isIncluded}
            />
          </div>
        ))}
      </div>
    </>
  )
}

SectionServicesModalContent.displayName = 'SectionServicesModalContent'
SectionServicesModalContent.propTypes = {
  context: PropTypes.string,
  services: PropTypes.array.isRequired
}

export default React.memo(SectionServicesModalContent)
